import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';

const EndTime: React.FC = () => {
  const { event } = useContext(EventDetailsContext);
  if (!event?.ends_at) return null;

  return (
    <span data-testid='formatted-end-time' className='text-uppercase'>
      {new Date(event?.ends_at).toLocaleTimeString(undefined, {
        timeZoneName: 'short',
        hour12: true,
        hour: 'numeric',
        minute: '2-digit',
      })}
    </span>
  );
};

export default EndTime;
